import styled from "styled-components";

export const StyledPreviewModal = styled.div`
    width: 100%;
    .banner {
        width: 100%;
        height: auto;
        max-height: 300px;
        object-fit: cover;
        border-radius: 14px 14px 0 0;
    }
    .details-wrap {
        padding: 0 20px;
        margin-top: -75px;
        .logo {
            display: block;
            width: 150px;
            height: 150px;
            border-radius: 50%;
            margin-bottom: 20px;
        }
        .title {
            display: block;
            color: var(--text-color);
            font-size: 28px;
            line-height: 32px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        .location-wrap {
            display: flex;
            align-items: center;
            gap: 9px;
            color: var(--text-color);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            margin-bottom: 20px;
        }
        .category-wrap {
            display: flex;
            align-items: center;
            gap: 10px;
            list-style: none;
            margin-bottom: 22px;
            li {
                padding: 10px;
                border-radius: 27px;
                color: var(--text-color);
                background: rgba(245, 126, 42, 0.15);
                box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
                backdrop-filter: blur(20px);
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
            }
        }
        .info-wrap {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
            .time-wrap {
                display: flex;
                align-items: center;
                gap: 11px;
                color: rgba(119, 119, 119, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .delivery-wrap {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 7px 10px;
                color: var(--white);
                background-color: var(--primary);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
                border-radius: 27px;
            }
        }
        .separator {
            width: 100%;
            border-bottom: 1px solid rgba(209, 209, 209, 1);
            margin-bottom: 30px;
        }
        .btn-holder {
            display: flex;
            justify-content: center;
        }
    }
`;
